//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction, CollapseAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { Photos } from '../Shared/Photos/Photos';
import { CustomFilter, CustomFilterOperator } from '../Shared/Models/CustomFilterModels';
import { ContactListConfig, ICAMSContact } from '../Shared/Contacts/ContactsModels';
import { ConsultationsCustomFilterFields, ConsultationsOrder } from './ConsultationsModels';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',

    consultationsRecordListPrintBtn = '#consultationsRecordListPrintBtn',
    consultationsRecordListQueryBtn = '#consultationsRecordListQueryBtn',
    consultationsRecordListContainer = '#consultationsRecordListContainer',
    consultationsRecordListCloseBtn = '#consultationsRecordListCloseBtn',
    consultationsPanel = '#consultationsPanel',
    consultationsGroupListPanel = '#consultationsGroupListPanel',
    consultationsGroupRadioGroup = '#consultationsGroupRadioGroup',
    consultationsRecordFilter = '#consultationsRecordFilter',
    consultationsRecordListPageAmount = '#consultationsRecordListPageAmount',
    consultationsRecordListShowingStartBtn = '#consultationsRecordListShowingStartBtn',
    consultationsRecordListShowingEndBtn = '#consultationsRecordListShowingEndBtn',
    consultationsRecordListShowingNextBtn = '#consultationsRecordListShowingNextBtn',
    consultationsRecordListShowingPrevBtn = '#consultationsRecordListShowingPrevBtn',
    consultationsRecordTable = '#consultationsRecordTable',
    consultationDetailsModal = '#consultationDetailsModal',
    consultationDetailsPathAffectedTable = '#consultationDetailsPathAffectedTable',
    consultationDetailsLegalAffectedPropertiesTable = '#consultationDetailsLegalAffectedPropertiesTable',
    consultationDetailsApplicantsTable = "#consultationDetailsApplicantsTable",
    consultationDetailsPreviousResponsesTable = '#consultationDetailsPreviousResponsesTable',
    consultationDetailsNoObjectionBtn = '#consultationDetailsNoObjectionBtn',
    consultationDetailsRespondBtn = '#consultationDetailsRespondBtn',
    consultationDetailsCloseBtn = '#consultationDetailsCloseBtn',
    consultationDetailsCancelBtn = '#consultationDetailsCancelBtn',
    consulteeResponseModal = '#consulteeResponseModal',
    consulteeResponseDraftBtn = '#consulteeResponseDraftBtn',
    consulteeResponseSubmitBtn = '#consulteeResponseSubmitBtn',
    consulteeResponseCloseBtn = '#consulteeResponseCloseBtn',
    consulteeResponseCancelBtn = '#consulteeResponseCancelBtn',
    consulteeResponseOtherModal = '#consulteeResponseOtherModal',
    consulteeResponseOtherForm = '#consulteeResponseOtherForm',
    consulteeResponseOtherSubmitBtn = '#consulteeResponseOtherSubmitBtn',
    consulteeResponseOtherCloseBtn = '#consulteeResponseOtherCloseBtn',
    consulteeResponseOtherCancelBtn = '#consulteeResponseOtherCancelBtn',
    consultationsSelectedView_Title ='#consultationsSelectedView_Title',
    consultationsSelectedView_TitleCount = '#consultationsSelectedView_TitleCount',
    consulteeResponseForm = '#consulteeResponseForm',
    consulteeResponseForm_singleContact = '#consulteeResponseForm [name="singleContact"]',
    consulteeResponseForm_contactSearch = '#consulteeResponseForm [name="contactSearch"]',
    consultationsRecordCount = '#consultationsRecordCount',
    consultationsRecordListShowing = '#consultationsRecordListShowing',
    recordCountIndividual = '#recordCountIndividual',
    consultationsQueryModal = '#consultationsQueryModal',
    consultationsQueryForm = '#consultationsQueryForm',
    consultationsQueryView_ContactTypeLUTList = '#consultationsQueryView_ContactTypeLUTList',
    consultationsQueryView_contactSearch = '#consultationsQueryView_contactSearch',
    consultationsQueryCancelBtn = '#consultationsQueryCancelBtn',
    consultationsQuerySubmitBtn = '#consultationsQuerySubmitBtn',
    consultationsRecordList_CustomFilters = '#consultationsRecordList_CustomFilters',
    consultationsRecordList_CustomFiltersBtn = '#consultationsRecordList_CustomFiltersBtn',
    consultationsRecordList_CustomFiltersClearBtn = '#consultationsRecordList_CustomFiltersClearBtn'
}

declare let moment: any; // Date helper from moment()

export class Consultations {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private currentPage: number = 0;
    private photos: Photos = new Photos();
    private currentUserContactRef: string;
    private currentSortOrder;
    private currentSortDirection: OrderDirection;

    // List of buttions in the action toolbar
    private listActionBtns = {
        viewprint: { btn: $(jqc.consultationsRecordListPrintBtn +' button'), enable: false },
        query: { btn: $(jqc.consultationsRecordListQueryBtn+' button'), enable: false }
    };

    private listResponseBtns = {
        noobjs: { btn: null, enable: false },
        respond: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(contactRef: string) {
        this.currentUserContactRef = contactRef;
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // When the module is furst loaded hide the main panels
        Utilities.GetControl(jqc.consultationsRecordListContainer).hide();

        // CLOSE BUTTONS
        Utilities.GetControl(jqc.consultationsRecordListCloseBtn).on('click', function () {
            Utilities.GetControl(jqc.consultationsPanel).removeClass('show');
            self.OpenGroupPanel();
        });

        // CONSUlTATIONS FILTER
        Utilities.GetControl(jqc.consultationsRecordFilter).on('change', function () { self.GetMyConsultations(); });
        Utilities.GetControl(jqc.consultationsRecordListPageAmount).on('change', function () {
            self.issueMaxNumberInList = $(jqc.consultationsRecordListPageAmount+' select').children("option:selected").val() as number;
            self.GetMyConsultations();
        });
        Utilities.GetControl(jqc.consultationsRecordList_CustomFiltersBtn).on("click", function () { self.GetMyConsultations(); });
        Utilities.GetControl(jqc.consultationsRecordList_CustomFiltersClearBtn).on("click", function () { self.clearCustomFilters(); self.GetMyConsultations(); });
        
        // CONSUlTATIONS PAGING BTNS
        Utilities.GetControl(jqc.consultationsRecordListShowingStartBtn).on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetMyConsultations();
        });
        Utilities.GetControl(jqc.consultationsRecordListShowingEndBtn).on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetMyConsultations();
        });
        Utilities.GetControl(jqc.consultationsRecordListShowingNextBtn).on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur();
            self.GetMyConsultations();
        });
        Utilities.GetControl(jqc.consultationsRecordListShowingPrevBtn).on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetMyConsultations();
        });

        // CONSUlTATION ACTION BUTTONS
        self.listActionBtns.viewprint.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.consultationsRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].LegalCode, featureType: FeatureType.LegalEvent };
            self.openDetailsPanel(data);
        });
        self.listActionBtns.query.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.consultationsRecordTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].LegalCode, featureType: FeatureType.LegalEvent };
            events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
        });
        
        // CONSULTATIONS TABLE
        // Initialize table
        var table: any = Utilities.GetControl(jqc.consultationsRecordTable)
        if (table != null && table.bootstrapTable) {
            table.bootstrapTable();

            table.on('click-row.bs.table', function (e, row, $element) {
            });
            table.on('check.bs.table', function (e, row, $element) {
                self.checkListVisibleButtons();
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkListVisibleButtons();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkListVisibleButtons();
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkListVisibleButtons();
            });
            table.on('sort.bs.table', function (e, name, order) {
                e.preventDefault();
                switch (name) {
                    case "LegalCode":
                        self.currentSortOrder = ConsultationsOrder.LegalCode;
                        break;
                    case "ConsultationStartDate":
                        self.currentSortOrder = ConsultationsOrder.ConsultationStartDate;
                        break;
                    case "CaseName":
                        self.currentSortOrder = ConsultationsOrder.CaseName;
                        break;
                    case "ConsultationRespondBy":
                        self.currentSortOrder = ConsultationsOrder.ConsultationRespondBy;
                        break;
                    default:
                        self.currentSortOrder = null;
                        break;
                }

                switch (order) {
                    case "asc":
                        self.currentSortDirection = OrderDirection.ASC;
                        break;
                    case "desc":
                        self.currentSortDirection = OrderDirection.DESC;
                        break;
                }

                self.GetMyConsultations();
            });
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "AnnotationCount") {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, true, FeatureType.LegalConsultation]));
                }
            });
        }
        
        // LEGAL GROUP BTNS
        Utilities.GetControl(jqc.consultationsGroupRadioGroup + ' input').on('change', function () {
            Utilities.GetControl(jqc.consultationsGroupListPanel).removeClass('show');
            self.OpenListPanel();
        });

        // Add filters on the list panel
        let listFilters: Array<IFilterDefinitionModel> = Utilities.GetControl(jqc.consultationsRecordListContainer + ' [data-listfilters]').data('listfilters');
        if (listFilters != null) {
            listFilters.forEach(f => {
                Utilities.GetControl(jqc.consultationsRecordFilter).append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
            });
        }

        // Initialize multiselects
        (Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterStatus"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });
        (Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterOrderType"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });
        //(Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterAdminArea"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public OpenGroupPanel = (): void => {
        const self = this;

        // rest page
        Utilities.GetControl(jqc.consultationsGroupRadioGroup + ' label').removeClass('active');
        Utilities.GetControl(jqc.consultationsGroupRadioGroup + ' input[type="radio"]:checked').prop('checked', false);
        self.resetPage();

        // Get count data
        self.GetLegalRegisterTypeCount();

        // Show the page
        Utilities.GetControl(jqc.consultationsGroupListPanel).addClass('show');
    }

    public OpenMyConsultations = (): void => {
        const self = this;

        // Reset radio btn
        Utilities.GetControl(jqc.consultationsGroupRadioGroup + ' input[type="radio"]:checked').prop('checked', false);
        Utilities.GetControl(jqc.consultationsGroupRadioGroup + ' [data-groupcode="MyC"]').prop('checked', true); // This will check the myconsultations radio button
        self.resetPage();

        self.OpenListPanel();
    }
    
    public OpenListPanel = (): void => {
        const self = this;

        // reset page
        self.resetPage();

        // Show the page
        Utilities.GetControl(jqc.consultationsRecordListContainer).show();
        Utilities.GetControl(jqc.consultationsPanel).addClass('show');

        // Get data
        self.GetMyConsultations();
    }

    public openDetailsPanel = (data: ICAMSKey): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load('/Consultations/ConsultationDetail', { legalCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Create);

            // Instantiate tables
            (Utilities.GetControl(jqc.consultationDetailsLegalAffectedPropertiesTable) as any).bootstrapTable();
            (Utilities.GetControl(jqc.consultationDetailsApplicantsTable) as any).bootstrapTable();

            //initialise photo uploader
            self.photos.setupUploader('#maintEditModal');

            // Get the paths affected data
            var tablepaths: any = Utilities.GetControl(jqc.consultationDetailsPathAffectedTable)
            tablepaths.bootstrapTable();
            self.GetLegalRouteData(data);

            // Get the consultation stage data
            var tableConsult: any = Utilities.GetControl(jqc.consultationDetailsPreviousResponsesTable)
            tableConsult.bootstrapTable();
            self.GetConsulteeResponsesByLegaLCode(data.code);

            tableConsult.on('check.bs.table', function (e, row, $element) {
                self.checkResponseVisibleButtons();
            });
            tableConsult.on('uncheck.bs.table', function (e, row, $element) {
                self.checkResponseVisibleButtons();
            });

            // Events on buttons
            self.listResponseBtns = {
                noobjs: { btn: Utilities.GetControl(jqc.consultationDetailsNoObjectionBtn), enable: false },
                respond: { btn: Utilities.GetControl(jqc.consultationDetailsRespondBtn), enable: false }
            };

            self.listResponseBtns.noobjs.btn.on('click', function (evt) {
                var table: any = Utilities.GetControl(jqc.consultationDetailsPreviousResponsesTable)
                let rows = table.bootstrapTable('getSelections');
                self.SendNoObjectResponse(data.code, rows[0].ConsultationID, rows[0].ID);
            });

            self.listResponseBtns.respond.btn.on('click', function (evt) {
                var table: any = Utilities.GetControl(jqc.consultationDetailsPreviousResponsesTable)
                let rows = table.bootstrapTable('getSelections');
                self.openConsulteeResponsePanel(data.code, rows[0].ConsultationID);
            });

            // Set btns off by default
            self.listResponseBtns.noobjs.btn.prop("disabled", true);
            self.listResponseBtns.respond.btn.prop("disabled", true);

            Utilities.GetControl(jqc.consultationDetailsCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Hide);
            });

            Utilities.GetControl(jqc.consultationDetailsCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Hide);
            });
        });
    }

    public openConsulteeResponsePanel = (legalCode: string, consultationID: number): void => {
        const self = this;
        Utilities.BlockUI();

        Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);

        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/Consultations/ConsulteeResponseView', { consultationID: consultationID, contactRef: self.currentUserContactRef, showResponseDate: false}, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Create);

            Utilities.GetControl(jqc.consulteeResponseForm_contactSearch).on('click', function (evt) {
                function callback(c: Array<ICAMSContact>) {
                    Utilities.GetControl(jqc.consulteeResponseForm_singleContact).val(c[0].ListName);
                    Utilities.GetControl(jqc.consulteeResponseForm + ' [name="ContactRef"]').val(c[0].ContactRef);
                    Utilities.GetControl(jqc.consulteeResponseForm + ' [name="NameAddress"]').val(c[0].ListName);
                }

                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));
            });
            
            Utilities.GetControl(jqc.consulteeResponseDraftBtn).on('click', function (evt) {
                self.UpdateResponseData(legalCode, true);
            });
            Utilities.GetControl(jqc.consulteeResponseSubmitBtn).on('click', function (evt) {
                self.UpdateResponseData(legalCode, false);
            });

            Utilities.GetControl(jqc.consulteeResponseCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);
            });

            Utilities.GetControl(jqc.consulteeResponseCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);
            });
        });
    }

    public openConsulteeResponseOtherPanel = (legalCode: string, consultationID: number): void => {
        const self = this;
        Utilities.BlockUI();

        Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);

        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/Consultations/ConsulteeResponseOtherView', { consultationID: consultationID, contactRef: self.currentUserContactRef }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Create);

            Utilities.GetControl(jqc.consulteeResponseOtherSubmitBtn).on('click', function (evt) {
                self.UpdateResponseOtherData(legalCode);
            });

            Utilities.GetControl(jqc.consulteeResponseOtherCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);
            });

            Utilities.GetControl(jqc.consulteeResponseOtherCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetMyConsultations = (): void => {
        const self = this;
     
        let legalRegisterType = Utilities.GetControl(jqc.consultationsGroupRadioGroup + " input[type='radio']:checked").data("groupcode");
        let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.consultationsRecordFilter).children("option:selected").data('filterdefinition');
        let order = ConsultationsOrder.LegalCode;
        let customfilters = self.getCustomFilters();

        let url = "/Consultations/GetMyConsultations";
        let query = {
            contactRef: self.currentUserContactRef,
            legalRegisterType: legalRegisterType,
            viewName: filterDef.viewName,
            customfilters: customfilters,
            order: self.currentSortOrder,
            orderDirection: self.currentSortDirection,
            Skip: self.currentPage * self.issueMaxNumberInList,
            Take: self.issueMaxNumberInList
        };

        Utilities.BlockUI(Utilities.GetControl(jqc.consultationsRecordListContainer));
        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data: Array<any> = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.consultationsRecordTable)
                        table.bootstrapTable('load', data)
                        self.updatePagingUI();

                        let selected = Utilities.GetControl(jqc.consultationsGroupRadioGroup + " input[type='radio']:checked");
                        let filterStr = selected.val() as any;
                        Utilities.GetControl(jqc.consultationsSelectedView_Title).html(filterStr);

                        var countStr = " (" + result.total + ")";
                        self.issueCountFromServer = result.total;
                        Utilities.GetControl(jqc.consultationsSelectedView_TitleCount).html(countStr);
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI(Utilities.GetControl(jqc.consultationsRecordListContainer));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetLegalRouteData = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Legal/GetLegalRoutes";
        let query = { legalCode: data.code };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.consultationDetailsPathAffectedTable)
                        table.bootstrapTable('load', data)
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetConsulteeResponsesByLegaLCode = (legalCode: string): void => {
        const self = this;

        let url = "/Consultations/GetConsulteeResponsesByLegaLCode";
        let query = { legalCode: legalCode, contactRef: self.currentUserContactRef };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.consultationDetailsPreviousResponsesTable)
                        table.bootstrapTable('load', data)
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetLegalRegisterTypeCount = (): void => {
        const self = this;

        let filterDef: IFilterDefinitionModel = Utilities.GetControl(jqc.consultationsRecordFilter).children("option:selected").data('filterdefinition');
        let customfilters = self.getCustomFilters();

        let url = "/Consultations/GetMyConsultationsByLegalRegisterTypeCount";
        let query = {
            contactRef: self.currentUserContactRef,
            viewName: filterDef.viewName,
            customfilters: customfilters
        };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        // Update the UI elements
                        var data: Array<{ key: string, value: number }> = result.data;
                        Utilities.GetControl(jqc.consultationsGroupRadioGroup + ' [data-groupcode]').each(function () {
                            var t = $(this).data('groupcode');
                            var v = data.find(d => d.key == t);
                            if (v != null) $(this).parent().find('[name="itemCount"]').html(' ('+v.value+')');
                        });
                    }
                    else {
                        toastr.error('Failed to get legal register type data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private UpdateResponseData = (legalCode: string, setAsDraft: boolean): void => {
        const self = this;

        var data = {};
        var formData = Utilities.GetControl(jqc.consulteeResponseForm).serializeArray();
        formData.forEach(d => data[d.name] = d.value);

        // Set the date
        if (setAsDraft == true) data['ResponseDate'] = null;
        else data['ResponseDate'] = new Date(Date.now()).toLocaleString().split(',')[0];

        let url = "/Consultations/UpdateConsulteeResponse";
        let query = { data: data };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.info('Updated response!')

                        Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                        Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);

                        self.GetConsulteeResponsesByLegaLCode(legalCode);
                        self.checkResponseVisibleButtons();
                    }
                    else {
                        toastr.info('Failed to update response!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private UpdateResponseOtherData = (legalCode: string): void => {
        const self = this;

        var data = {};
        var formData = Utilities.GetControl(jqc.consulteeResponseOtherForm).serializeArray();
        formData.forEach(d => data[d.name] = d.value);

        let url = "/Consultations/UpdateConsulteeResponseOther";
        let query = { data: data };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.info('Updated response!')

                        Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Hide);
                        Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);

                        self.GetConsulteeResponsesByLegaLCode(legalCode);
                        self.checkResponseVisibleButtons();
                    }
                    else {
                        toastr.info('Failed to update response!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private SendNoObjectResponse = (legalCode: string, consultationID: number, ID: number): void => {
        const self = this;

        let url = "/Consultations/UpdateConsulteeNoObjection";
        let query = { ID: ID, consultationID: consultationID };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.info('Updated response!')

                        Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                        Utilities.GetModal(jqc.consultationDetailsModal, ModalAction.Show);

                        self.GetConsulteeResponsesByLegaLCode(legalCode);
                    }
                    else {
                        toastr.info('Failed to update response!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private checkListVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.consultationsRecordTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.listActionBtns).forEach(k => {
            self.listActionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        if (rows && rows.length == 1) {
            self.listActionBtns.viewprint.enable = true;
            self.listActionBtns.query.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.listActionBtns).forEach(k => {
            if (self.listActionBtns[k].enable == true) self.listActionBtns[k].btn.prop("disabled", false);
            else self.listActionBtns[k].btn.prop("disabled", true);
        });
    }

    private checkResponseVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.consultationDetailsPreviousResponsesTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.listResponseBtns).forEach(k => {
            self.listResponseBtns[k].enable = false;
        });

        // Check response date
        var btnFlag = true;
        if (rows && rows.length == 1 && rows[0].ConsultationEndDate != null && moment(rows[0].ConsultationEndDate).isValid() == true) {
            var now = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            var endDate = moment(rows[0].ConsultationEndDate);
            if (now > endDate) btnFlag = false;
        }

        // Then switch on the ones we want depending on the nde type
        //if (rows && rows.length == 1 && rows[0].ResponseDate == null) {
        if (rows && rows.length == 1 && btnFlag == true) {
            self.listResponseBtns.noobjs.enable = true;
            self.listResponseBtns.respond.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.listResponseBtns).forEach(k => {
            if (self.listResponseBtns[k].enable == true) self.listResponseBtns[k].btn.prop("disabled", false);
            else self.listResponseBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { Utilities.GetControl(jqc.consultationsRecordCount).html(' (' + self.issueCountFromServer + ')'); } else { Utilities.GetControl(jqc.recordCountIndividual).html(); }
        Utilities.GetControl(jqc.consultationsRecordListShowing).html((self.currentPage + 1).toString());

        self.checkListVisibleButtons();
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;
        Utilities.GetControl(jqc.consultationsSelectedView_Title).html("");
        Utilities.GetControl(jqc.consultationsSelectedView_TitleCount).html("");
        Utilities.GetControl(jqc.consultationsRecordListContainer).hide();

        this.updatePagingUI();

        // Reset custom filters
        this.clearCustomFilters();
        Utilities.GetCollapse(jqc.consultationsRecordList_CustomFilters, CollapseAction.Hide);
    }

    private getCustomFilters = (): CustomFilter[] => {
        const self = this;
        var customFilters: CustomFilter[] = [];
        
        // Custom filters
        let filterStatus = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterStatus"]').val().toString();
        if (filterStatus != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "Status"), operator: CustomFilterOperator.Or, searchValue: filterStatus });

        let orderType = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterOrderType"]').val().toString();
        if (orderType != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "OrderTypeCode"), operator: CustomFilterOperator.Or, searchValue: orderType });

        let postcode = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterPostcode"]').val().toString();
        if (postcode != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "Postcode"), operator: CustomFilterOperator.Contains, searchValue: postcode });

        let adminAreaList = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterAdminArea"]').val().toString(); 
        //if (adminAreaList != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "AdminAreaList"), operator: CustomFilterOperator.Contains, searchValue: adminAreaList });
        if (adminAreaList != "") {
            // THIS IS SET TO TEXT AS THIS FILTER SEARCHES ON TEH NAME AND NOT THE CODE
            let adminAreaListText = ""; 
            Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterAdminArea"]').children("option:selected").each(function() {
                adminAreaListText = $(this).text();
                //if (adminAreaListText != "") adminAreaListText = adminAreaListText + "," + $(this).text();
            });
            customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "AdminAreaList"), operator: CustomFilterOperator.Contains, searchValue: adminAreaListText });
        }

        let applicantList = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterApplicantList"]').val().toString();
        if (applicantList != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "ApplicantList"), operator: CustomFilterOperator.Contains, searchValue: applicantList });

        let location = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterLocation"]').val().toString();
        if (location != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "Location"), operator: CustomFilterOperator.Contains, searchValue: location });

        let ref = Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="Ref"]').val().toString();
        if (ref != "") customFilters.push({ field: ConsultationsCustomFilterFields.Fields.find(f => f.fieldName == "Ref"), operator: CustomFilterOperator.Contains, searchValue: ref });

        return customFilters;
    }

    private clearCustomFilters = (): void => {
        (Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterOrderType"]') as any).multiselect('deselectAll', false);
        (Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterStatus"]') as any).multiselect('deselectAll', false);
        Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterPostcode"]').val(null);
        Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterAdminArea"]').val(null);
        Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterApplicantList"]').val(null);
        Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="FilterLocation"]').val(null);
        Utilities.GetControl(jqc.consultationsRecordList_CustomFilters + ' [name="Ref"]').val(null);
    }
    
}




